let instance = null;
/**
 * Ditap 알림창의 배경 클래스.</br>
 * The background class of the Ditap notification window.
 * @alias DitapMask
 * @constructor
 *
 * @param {Element} [parent=document.querySelector("body")] 부모 요소.</br>Parent element to which the mask will be inserted.
 *
 * @example
 *
 * const container = document.getElementById("ditapContainer")
 * const mask = new Ditap.DitapMask(container);
 *
 * mask.open();
 */
class DitapMask {
  constructor(parent) {
    if (!instance) {
      instance = this;
      if (!parent) {
        this._parent = document.querySelector("body");
      } else {
        this._parent = parent;
      }
      this._mask = document.createElement("div");
      this._mask.classList.add("ditap-mask", "hide");
      this._parent.appendChild(this._mask);
    }
    return instance;
  }

  /*
   * 마스크 부모 요소.</br>
   * The parent element of the mask.
   * @type {Element}
   */
  get parent() {
    return this._parent;
  }
  set parent(parent) {
    this._parent = parent;
  }

  /*
   * 마스크 요소.</br>
   * Mask element.
   * @type {Element}
   */
  get mask() {
    return this._mask;
  }
  set mask(mask) {
    this._mask = mask;
  }

  /**
   * 마스크 요소 활성화.</br>
   * Enable mask element.
   */
  open() {
    this.mask?.classList.remove("hide");
  }

  /**
   * 모바일 전용 마스크 요소 활성화.</br>
   * Enable mask element.
   */
  openMobile() {
    this.mask?.classList.add("ditap-mobile-mask");
    this.mask?.classList.remove("hide");
  }

  /**
   * 마스크 비활성화.</br>
   * Disable mask element.
   */
  close() {
    this.mask?.classList.add("hide");
  }

  /**
   * 모바일 전용 마스크 요소 비활성화.</br>
   * Disable mask element.
   */
  closeMobile() {
    this.mask?.classList.add("hide");
    this.mask?.classList.remove("ditap-mobile-mask");
  }

  /**
   * 마스크 파괴.</br>
   * destroy mask element.
   */
  destroy() {
    if (this.mask && this.mask.parentNode === this.parent) {
      this.parent.removeChild(this.mask);
    }
    instance = null;
  }
}
export default DitapMask;
